"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _ComparisonDataDisplay = require("../ComparisonDataDisplay.styled");
var _SpecBox = _interopRequireDefault(require("./SpecBox"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
const GroupSpecs = _ref => {
  let {
    spec,
    label,
    index,
    displayedProducts,
    showAllProducts,
    applyShowDifferences
  } = _ref;
  let shouldDisplayRow = false;
  const result = /*#__PURE__*/_react.default.createElement(_ComparisonDataDisplay.StyledGridRow, {
    key: index,
    noGutters: true
  }, displayedProducts === null || displayedProducts === void 0 ? void 0 : displayedProducts.map((productId, rowPlacement) => {
    var _spec$values$productI;
    const shouldDisplaySpecification = !!((_spec$values$productI = spec.values[productId]) !== null && _spec$values$productI !== void 0 && _spec$values$productI.map(value => value.text).reduce((a, b) => a || !!b, false));
    shouldDisplayRow = shouldDisplaySpecification || shouldDisplayRow;
    return /*#__PURE__*/_react.default.createElement(_SpecBox.default, {
      spec: spec,
      index: index,
      key: rowPlacement,
      productId: productId,
      displayedProducts: displayedProducts,
      rowPlacement: rowPlacement,
      showAllProducts: showAllProducts,
      applyShowDifferences: applyShowDifferences,
      label: label
    });
  }));
  return shouldDisplayRow ? result : null;
};
var _default = GroupSpecs;
exports.default = _default;